import { mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of, concat } from 'rxjs';
import { createLookupHash } from '../../../services/hash-service';
import * as ShipmentsNavAction from '../../../store/shipments/nav/shipments.nav.actions';
import * as OrdersNavAction from '../../../store/orders/nav/orders.nav.actions';
import Global from '../../../store/global-selectors';
import * as BatchGridApi from '../../../store/batches/grid/batches.grid.api';
import * as BatchesActions from '../../../store/batches/batches.actions';
import * as BatchesDetailsActions from '../../../store/batches/details/batch.details.actions';
import * as BatchesGridActions from '../../../store/batches/grid/batches.grid.actions';
import * as BulkActions from '../../../store/bulk/bulk.actions';
import * as EntitiesActions from '../../../store/entities/entities.actions';
import * as Actions from './batches.nav.actions';
import {
  BATCHES_VIEW_ID,
  BATCHES_ARCHIVED_VIEW_ID,
  BATCHES_PROCESSED_VIEW_ID,
  BATCHES_OPEN_VIEW_ID,
} from '../../../components/shipping-grid/views/view-id-constants';
import { FeatureFlags } from '../../../feature-flags/feature-flags';
import { getSelectedViewFromPathName } from '../../../pages/shipping-page/shipping-left-nav/shipping-left-nav-context';
import { BATCHES_ID } from '../../../pages/orders-page/orders-page-view-constants';

const tabFilterToViewIdMap = {
  open: BATCHES_OPEN_VIEW_ID,
  processed: BATCHES_PROCESSED_VIEW_ID,
  archived: BATCHES_ARCHIVED_VIEW_ID,
};

export const batchesUpdateShippingPageLeftNav = (action$, _, { history }) =>
  action$.pipe(
    ofType(Actions.BATCHES_UPDATE_SHIPPING_PAGE_LEFT_NAV),
    mergeMap(({ tabFilter }) => {
      const view = getSelectedViewFromPathName(history.location.pathname);

      if (!view.id.includes(BATCHES_VIEW_ID)) {
        const viewId = tabFilterToViewIdMap[tabFilter] || BATCHES_VIEW_ID;
        return of(ShipmentsNavAction.shipmentsChangeView(viewId, false));
      }
      return EMPTY;
    }),
  );

export const ordersViewsChanged = (action$, { getState }, { history }) =>
  action$.pipe(
    ofType(Actions.BATCHES_UPDATE_ORDERS_PAGE_LEFT_NAV),
    mergeMap(() => {
      const stores = Global.selectSellerActiveStores(getState());
      const statusViewId = getSelectedViewFromPathName(history?.location?.pathname, stores)?.id;
      if (statusViewId !== BATCHES_ID) {
        return concat(of(OrdersNavAction.clearSearchInput()));
      }
      return EMPTY;
    }),
  );

export const getBatchesMenuDataEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(
      Actions.GET_BATCH_MENU_DATA,
      Actions.LOAD_MORE_ACTIVE_BATCHES,
      BatchesActions.ADD_SALES_ORDERS_TO_BATCH_SUCCESS,
      BatchesActions.ADD_FULFILLMENT_PLANS_TO_BATCH_SUCCESS,
      BatchesActions.ADDED_SALES_ORDERS_TO_CREATED_BATCH_SUCCESS,
      BatchesActions.ADDED_FULFILLMENT_PLANS_TO_CREATED_BATCH_SUCCESS,
      BatchesGridActions.ARCHIVE_BATCHES_SUCCESS,
      BatchesDetailsActions.REMOVE_FULFILLMENT_PLANS_FROM_BATCH_SUCCESS,
    ),
    mergeMap(() => {
      const page = 1;
      const pageSize = Global.selectBatchesNavPageSize(getState());
      const selectedTab = 'open';
      const sortBy = 'CreatedDateDesc';
      const currentUserId = Global.selectUserCurrentUserId(getState());
      return BatchGridApi.getBatchRows(page, pageSize, selectedTab, sortBy).pipe(
        mergeMap((batchData) => {
          // NOTE: SPD-9235 - This is a ephemeral piece of logic that patches fulfillmentPlanSets within entities until we consolidate the logic to use entities.
          const { pageData } = batchData;
          const fulfillmentPlanSetEntities =
            pageData.map((fps) => ({
              fulfillmentPlanSetId: fps.fulfillmentPlanSetId,
              fulfillmentPlanSetName: fps.name,
            })) || [];
          return of(
            Actions.getBatchMenuDataSuccess(batchData, currentUserId),
            EntitiesActions.entitiesBulkload({
              fulfillmentPlanSets: createLookupHash(fulfillmentPlanSetEntities, 'fulfillmentPlanSetId'),
            }),
          );
        }),
        catchError(() => EMPTY),
      ); // TODO: handle error case
    }),
  );
};

export const createLabelLastMessageBatchLoad = (action$, { getState }) => {
  return action$.pipe(
    ofType(BulkActions.BULK_PROCESSING_CREATE_LABEL_FINAL_MESSAGE),
    mergeMap(({ message }) => {
      const featureFlags = new FeatureFlags(getState());
      if (!featureFlags.shouldBypassBatchesGridRefresh) {
        return of(Actions.getBatchMenuData());
      }
      const currentUserId = Global.selectUserCurrentUserId(getState());
      const { status } = message ?? {};
      if (status?.SingleLabel || status?.UserID !== currentUserId) {
        return EMPTY;
      }

      return of(Actions.getBatchMenuData());
    }),
  );
};
